import * as React from 'react';
import { TApiEquipmentEntity } from '../../types/Equipment';
import { useEquipmentListStyles } from './EquipmentList.styles';
import { useHistory } from 'react-router-dom';
import { reverse } from 'named-urls';
import { routes } from '../../Routes';
import Image from '../cms/Image';
import { useTranslation } from 'react-i18next';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface IEquipmentListProps {
  equipment?: Array<TApiEquipmentEntity>;
}

const EquipmentList: React.FC<IEquipmentListProps> = ({
  equipment,
}): JSX.Element => {
  const classes = useEquipmentListStyles({});
  const history = useHistory();
  const { t } = useTranslation();

  const handleClick = (id: number) => {
    history.push(reverse(routes.equipmentItem, { id }));
  };

  return (
    <List>
      {equipment && equipment.length > 0 ? (
        equipment.map((item) => (
          <ListItem
            key={item.id}
            className={classes.listItem}
            button
            onClick={() => handleClick(item.id)}
          >
            <div className={classes.imageContainer}>
              {item.image ? (
                <Image
                  image={{
                    url: item.image as string,
                    name: item.name as string,
                  }}
                  tileImage={true}
                />
              ) : (
                <i
                  className={`fas fa-wrench ${classes.fallbackIcon}`}
                />
              )}
            </div>
            <Box flex={1} overflow="hidden">
              <Typography className={classes.itemName}>
                {item.name}
              </Typography>
              {item.model && (
                <Typography className={classes.itemDetail}>
                  {item.model}
                </Typography>
              )}
              {item.serialVin && (
                <Typography className={classes.itemDetail}>
                  {t('equipment.app.serial_vin')}: {item.serialVin}
                </Typography>
              )}
            </Box>
          </ListItem>
        ))
      ) : (
        <Box py={2} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            {t('equipment.no_results')}
          </Typography>
        </Box>
      )}
    </List>
  );
};

export default EquipmentList;
